export const translationsEL: Record<string, string> = {
  'Meta Author': 'Χρίστος Κορομπόκης',
  'Meta Content': 'el',
  'html lang': 'el',
  'Menu Title SSR': 'CK-Games Παντομίμα Tik-Tak-Boom',
  'CK-Games': 'CK-Games',
  Pantomime: 'Παντομίμα',
  'Tik-Tak-Boom': 'Tik-Tak-Boom',
  CONTINUE: 'ΣΥΝΕΧΕΙΑ',
  BACK: 'ΠΙΣΩ',
  'Player, it is your turn': '%0, είναι η σειρά σου!',
  'Pantomime Description HTML': `
        <p>
          Μάζεψε τους φίλους σου και διασκεδάστε παίζοντας
          <strong> Παντομίμα</strong>.
        </p>
        <p>
          H Παντομίμα είναι ένα ξεκαρδιστικό παιχνίδι που περιλαμβάνεται στα
          <strong> CK-Games</strong>. Σκοπός είναι να περιγράψεις ταινίες
          στους συμπαίκτες σου χωρίς να μιλήσεις.
        </p>
        <h2>Πώς παίζεται η Παντομίμα;</h2>
        <ul>
          <li>
            Χωριστείτε σε<strong> δύο ή περισσότερες ομάδες</strong>
          </li>
          <li>
            Επιλέξτε το<strong> σκορ νίκης</strong>
            <br />
            Αν για παράδειγμα επιλέξετε τις πέντε (5) νίκες, τότε το παιχνίδι θα
            ολοκληρωθεί όταν μία από τις ομάδες φτάσει στις 5 νίκες και όλες οι
            ομάδες έχουν παίξει τον ίδιο αριθμό γύρων. Το ενδεχόμενο της ισοπαλίας
            είναι υπαρκτό.
          </li>
          <li>
            Επιλέξτε τον<strong> χρόνο</strong> που θα έχει η κάθε ομάδα στη
            διάθεσή της για να βρεί τη ζητούμενη ταινία
          </li>
          <li>
            Πριν διαγωνιστεί η κάθε ομάδα, οι αντίπαλες ομάδες
            <strong> επιλέγουν μία (1)</strong> από τις δύο (2) διαθέσιμες ταινίες.
          </li>
          <li>
            Όταν έρχεται η σειρά της ομάδας σου, τότε ένας παίκτης αναλαμβάνει να
            <strong> πειγράψει</strong> την ταινία που βλέπει στην οθόνη
            <strong> χωρίς να μιλήσει.</strong> <br />
            Αν τη βρείτε τότε κερδίζετε έναν πόντο, αν όχι τότε κρίμα.
          </li>
          <li>
            Όταν μία ή περισσότερες ομάδες φτάσει το σκορ νίκης, το παιχνίδι
            ολοκληρώνεται.
          </li>
        </ul>
      `,
  'Tik-Tak-Boom Description HTML': `
        <p>
          Μάζεψε τους φίλους σου και διασκεδάστε παίζοντας
          <strong> Tik-Tak-Boom</strong>.
        </p>
        <p>
          To Tik-Tak-Boom είναι ένα ξεκαρδιστικό παιχνίδι που περιλαμβάνεται στα
          <strong> CK-Games</strong>. όπου σκοπός είναι να πεις την κατάλληλη λέξη
          πρωτού σκάσει η βόμβα στα χέρια σου.
        </p>
        <h2>Πώς παίζεται το Tik-Tak-Boom;</h2>
        <ul>
          <li>Καταχωρίστε τα ονόματά σας.</li>
          <li>
            Επιλέξτε το<strong> σκορ νίκης</strong>.
            <br />
            Αν για παράδειγμα επιλέξετε τις πέντε (5) νίκες, τότε το παιχνίδι θα
            ολοκληρωθεί όταν ένας από τους παίκτες φτάσει στις 5 νίκες. Το
            ενδεχόμενο της ισοπαλίας δεν είναι υπαρκτό.
          </li>
          <li>
            Όταν έρχεται η σειρά σου, τότε πρέπει να
            <strong> πεις την κατάλληλη λέξη</strong> και να πατήσεις στο κουμπί
            ώστε να παίξει ο επόμενος παίκτης. H λέξη που θα πεις πρέπει να
            περιλαμβάνει τη συλλαβή που βλέπεις στην οθόνη και στην κατάλληλη
            θέση. <br />
            Αν στην οθόνη αναγράφεται το "Tik..." τότε η λέξη πρέπει να ξεκινάει από
            την επιλεγμενη συλλαβή. <br />
            Αν στην οθόνη αναγράφεται το "...Tak" τότε η λέξη πρέπει να τελειώνει με
            την επιλεγμενη συλλαβή. <br />
            Αν στην οθόνη αναγράφεται το "Tik...Tak" τότε η λέξη πρέπει απλά να
            περιλαμβάνει την επιλεγμενη συλλαβή. <br />
          </li>
          <li>
            Όταν η βόμβα σκάσει στα χέρια ενός παίκτη τότε, ο παίκτης
            <strong> δε συμμετέχει στο παιχνίδι μέχρι να ολοκληρωθεί ο γύρος</strong>
            . <br />Ο γύρος ολοκληρώνεται όταν μείνει μόνο ένας παίκτης, ο οποίος
            είναι αυτός που κερδίζει και τον πόντο.
          </li>
          <li>
            Όταν ένας παίκτης φτάσει το σκορ νίκης, το παιχνίδι ολοκληρώνεται.
          </li>
        </ul>
    `,
  Home: 'Αρχική',
  'Team, it is your turn': '%0, είναι η σειρά σας!',
  'Game Completed': 'Το Παιχνίδι Ολοκληρώθηκε',
  'Restart Game': 'Επανεκκίνηση Παιχνιδιού',
  'Player, bomb exploded in your hands': '%0, η βόμβα έσκασε στα χέρια σου!',
  'Player Setup': 'Εισαγωγή Παικτών',
  'Add Player': 'Προσθήκη Παίκτη',
  'Next Player': 'Επόμενος Παίκτης',
  'Previous Player': 'Προηγούμενος Παίκτης',
  'Tik Mode Description': 'Η λέξη πρέπει να ξεκινά με την επιλεγμένη συλλαβή',
  'Tak Mode Description': 'Η λέξη πρέπει να τελειώνει με την επιλεγμένη συλλαβή',
  'Tik...Tak Mode Description': 'Η λέξη πρέπει απλά να περιέχει την επιλεγμένη συλλαβή',
  Scoreboard: 'Βαθμολογία',
  'Choose Winning Score': 'Επιλέξτε το σκορ νίκης',
  'Tik-Tak-Boom Meta Title': 'CK-Games: Tik-Tak-Boom',
  'Tik-Tak-Boom Meta Canonical Pathname': 'tik-tak-boom/',
  'Tik-Tak-Boom Meta Description': 'Διασκέδασε με την παρέα σου παίζοντας Tik-Tak-Boom.',
  'Tik-Tak-Boom Meta Keywords': 'παιχνίδι, διασκέδαση, νίκη, ήττα, ισοπαλία, tik-tak-boom, tik, tak, boom, βόμβα',
  'Choose Available Time': 'Επιλέξτε τον διαθέσιμο χρόνο',
  Seconds: 'Δευτερόλεπτα',
  'Movie Not Found': 'Η Ταινία Δε Βρέθηκε!',
  'Movie Found': 'Η Ταινία Βρέθηκε!',
  'Team, your turn completed': '%0, η σειρά σας ολοκληρώθηκε!',
  'Pantomime Meta Title': 'CK-Games: Παντομίμα',
  'Pantomime Meta Canonical Pathname': 'pantomime/',
  'Pantomime Meta Description': 'Διασκέδασε με την παρέα σου παίζοντας Παντομίμα.',
  'Pantomime Meta Keywords': 'παιχνίδι, διασκέδαση, φίλοι, παρέα, παντομίμα, μίμηση, ταινία, νίκη, ήττα, ισοπαλία',
  'Team Setup': 'Εισαγωγή Ομάδων',
  'Add Team': 'Προσθήκη Ομάδας',
  'Home Meta Title': 'CK-Games',
  'Home Meta Canonical Pathname': '',
  'Home Meta Description': 'Εσύ επιλέγεις πως θα διασκεδάσεις με την παρέα σου. Παίξτε Παντομίμα ή Tik-Tak-Boom.',
  'Home Meta Keywords':
    'παιχνίδι, διασκέδαση, φίλοι, παρέα, παντομίμα, μίμηση, ταινία, νίκη, ήττα, ισοπαλία, tik-tak-boom, tik, tak, boom, βόμβα',
  'Open Menu': 'Άνοιξε το Μενού',
  'Close Menu': 'Κλείσε το Μενού'
};
